import { CCA_TRANSACTION_AMOUNT_LIMIT } from '@/shared/cca/constants/cca.constant';

export const isCcaAmountLimitValid = (isCCA: boolean, originAmount: number) => {
  return Boolean(isCCA && originAmount <= CCA_TRANSACTION_AMOUNT_LIMIT);
};
